import React, { useState } from 'react';
import { BeatLoader } from 'react-spinners';
import './cartao-RequestExtract-modal.css';
import ReactModal from 'react-modal';
import { BoxModal } from '../../boxModal';
import { toast } from 'react-toastify';
import { FilterButtons } from './FilterButtons';
import { DateInput } from '../../Shared/DateInput';
import { ErrorMessage } from '../../Shared/ErrorMessage';
import { MessageModal } from '../../Shared/MessageModal/MessageModal';
import { FilterEnum } from '../../../services/enums';
import { useCards } from '../../../hooks/useCards';
export const ModalRequestExtract = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const { sendEmailEstatement } = useCards();
  const handleRequestExtract = async () => {
    setSubmitted(true);
    setLoading(true);

    if (!startDate || !endDate) {
      setError('Por favor, preencha todas as datas.');
      setLoading(false);
      return;
    }
    try {
      const data = {
        initialDate: startDate,
        finalDate: endDate,
      };
      const response = await sendEmailEstatement(data);
      if (response) {
        setIsSuccessOpen(true);
        setError('');
      } else {
        throw new Error('Erro ao enviar extrato');
      }
    } catch (err) {
      console.error('Erro ao enviar extrato:', err);
      setIsErrorOpen(true);
    } finally {
      setLoading(false);
    }
  };
  const handleCloseSuccessModal = () => {
    setIsSuccessOpen(false);
    onClose();
  };
  const handleCloseErrorModal = () => {
    setIsErrorOpen(false);
    onClose();
  };
  const handleInputChange = (field, value) => {
    if (field === 'startDate') {
      setStartDate(value);
    } else if (field === 'endDate') {
      setEndDate(value);
    }
    if (value && (field === 'startDate' ? endDate : startDate)) {
      setError('');
    }
  };
  const getDateRange = {
    [FilterEnum.TODAY]: () => {
      const today = new Date();
      return { start: today, end: today };
    },
    [FilterEnum.CURRENT_MONTH]: () => {
      const today = new Date();
      return {
        start: new Date(today.getFullYear(), today.getMonth(), 1),
        end: new Date(today.getFullYear(), today.getMonth() + 1, 0)
      };
    },
    [FilterEnum.PREVIOUS_MONTH]: () => {
      const today = new Date();
      return {
        start: new Date(today.getFullYear(), today.getMonth() - 1, 1),
        end: new Date(today.getFullYear(), today.getMonth(), 0)
      };
    },
    [FilterEnum.LAST_60_DAYS]: () => {
      const today = new Date();
      const start = new Date();
      start.setDate(today.getDate() - 60);
      return { start, end: today };
    },
    [FilterEnum.LAST_90_DAYS]: () => {
      const today = new Date();
      const start = new Date();
      start.setDate(today.getDate() - 90);
      return { start, end: today };
    }
  };

  const handleFilter = (filter) => {
    const range = getDateRange[filter];

    if (!range) return;

    const { start, end } = range();
    setStartDate(start.toISOString().split('T')[0]);
    setEndDate(end.toISOString().split('T')[0]);
    setError('');
  };

  const filters = [
    { label: 'Hoje', value: FilterEnum.TODAY },
    { label: 'Mês Atual', value: FilterEnum.CURRENT_MONTH },
    { label: 'Mês Anterior', value: FilterEnum.PREVIOUS_MONTH },
    { label: 'Últimos 60 Dias', value: FilterEnum.LAST_60_DAYS },
    { label: 'Últimos 90 Dias', value: FilterEnum.LAST_90_DAYS },
  ];
  return (
    <>
      <ReactModal
        isOpen={isOpen && !isSuccessOpen && !isErrorOpen}
        className="change-modal"
        overlayClassName="overlay-change-password-modal"
      >
        <BoxModal maxWidth={800} title="Solicitação de extrato" close={onClose}>
          <div>
            <div className="filters-container">
              <p className="filters-label">Filtros rápidos</p>
              <div className="filter-buttons">
                <FilterButtons filters={filters} onFilter={handleFilter} />
              </div>
            </div>
            <div className="date-input-container">
              <DateInput
                label="Data Inicial"
                value={startDate}
                onChange={(e) => handleInputChange('startDate', e.target.value)}
                showError={submitted && !startDate}
              />
              <DateInput
                label="Data Final"
                value={endDate}
                onChange={(e) => handleInputChange('endDate', e.target.value)}
                showError={submitted && !endDate}
              />
            </div>
            {error && <ErrorMessage message={error} />}
            <div className="modal-buttons-requestExtract">
              <button
                className="save-button-requestExtract"
                onClick={handleRequestExtract}
                disabled={loading}
              >
                {loading ? <BeatLoader size={10} color="#fff" /> : 'Solicitar'}
              </button>
              <button
                className="cancel-button-requestExtract"
                onClick={onClose}
                disabled={loading}
              >
                Fechar
              </button>
            </div>
          </div>
        </BoxModal>
      </ReactModal>
      <ReactModal
        isOpen={isSuccessOpen}
        className="change-modal"
        overlayClassName="overlay-change-password-modal"
      >
        <BoxModal
          maxWidth={600}
          title="Solicitação de extrato"
          close={handleCloseSuccessModal}
        >
          <MessageModal
            variant="success"
            message="Extrato gerado com sucesso!"
            onClose={handleCloseSuccessModal}
          />
          <div className="modal-buttons-sucess-requestExtract">
            <button
              className="save-button-sucess-requestExtract"
              onClick={() => toast('Download iniciado!')}
            >
              Baixar
            </button>
            <button
              className="cancel-button-sucess-requestExtract"
              onClick={handleCloseSuccessModal}
            >
              Fechar
            </button>
          </div>
        </BoxModal>
      </ReactModal>
      <ReactModal
        isOpen={isErrorOpen}
        className="change-modal"
        overlayClassName="overlay-change-password-modal"
      >
        <BoxModal
          maxWidth={700}
          title="Solicitação de extrato"
          close={handleCloseErrorModal}
        >
          <MessageModal
            variant="error"
            message="Ocorreu um erro ao tentar gerar o extrato."
            onClose={handleCloseErrorModal}
          />
          <div className="modal-buttons-error-requestExtract">
            <button
              className="close-button-error-requestExtract"
              onClick={handleCloseErrorModal}
            >
              Fechar
            </button>
          </div>
        </BoxModal>
      </ReactModal>
    </>
  );
};